import React, { useEffect, useState } from "react";
import sliderImage1 from "../../images/slider-perks-img1.jpeg";
import sliderImage2 from "../../images/slider-perks-img2.jpeg";
import sliderImage3 from "../../images/slider-perks-img3.jpeg";
import sliderImage4 from "../../images/slider-perks-img4.jpeg";
import sliderImage5 from "../../images/slider-perks-img5.jpeg";
/* eslint-disable import/first */
const Flickity =
  typeof window !== `undefined` ? require('flickity') : null;
import '../../sass/flickity.min.css';
import $ from 'jquery';
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

function CareerPerks(props) {
  let flkty;
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    flkty = new Flickity('.main-carousel', {
      freeScroll: true,
      contain: true,
      wrapAround: true, // infinite scroll
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 1500
    });

    const handleScroll = () => {
      let sTop = $(document).scrollTop();
      let hgt = $(document).height();
      let fValue = (sTop / hgt) * 100;
      $('.main-carousel .flickity-slider').css('left', -10 * fValue);
    };
    // window.addEventListener('scroll', handleScroll, true);

    //unmount
    return () => {
      //window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  const { title, header, content, listItems } = props.data;
  return (
    <InView as="div" onChange={inView => setIsVisible(inView)} className="career-perks section-gap">
      <div className="section-gap-small">
        <div className="container">
          <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
          <h2 className="h3 secondary-font">{header}</h2>
          {content}
        </div>
      </div>
      <div className="perks-listing section-gap">
        <div className="container">
          <ul className="list-style-line two-column-list">
            {listItems && listItems.map((item, index) => {
              return (<li key={index}>
                {item.content}
              </li>);
            })}
          </ul>
        </div>
      </div>

      <div className="career-perks-slider" >
        <div className="main-carousel">
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage1} title="Celebrations and Events" alt="celebrations and events" />
            </LazyLoad>
          </div>
          <div className="carousel-cell ">
            <LazyLoad>
              <img src={sliderImage2} title="Continues Learning" alt="continues learning" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage3} title="Outstanding Colleague" alt="outstanding colleague" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage4} title="Flexible Environment" alt="flexible environmente" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage5} title="Training and Development" alt="training and development" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage1} title="Celebrations and Events" alt="celebrations and events" />
            </LazyLoad>
          </div>
          <div className="carousel-cell ">
            <LazyLoad>
              <img src={sliderImage2} title="Continues Learning" alt="continues learning" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage3} title="Outstanding Colleague" alt="outstanding colleague" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage4} title="Flexible Environment" alt="flexible environmente" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage5} title="Training and Development" alt="training and development" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage1} title="Celebrations and Events" alt="celebrations and events" />
            </LazyLoad>
          </div>
          <div className="carousel-cell ">
            <LazyLoad>
              <img src={sliderImage2} title="Continues Learning" alt="continues learning" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage3} title="Outstanding Colleague" alt="outstanding colleague" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage4} title="Flexible Environment" alt="flexible environmente" />
            </LazyLoad>
          </div>
          <div className="carousel-cell">
            <LazyLoad>
              <img src={sliderImage5} title="Training and Development" alt="training and development" />
            </LazyLoad>
          </div>
        </div>
      </div>
      {flkty}
    </InView>
  );
};

export default CareerPerks;